import type {
  AssessmentProcessingStatus,
  FirestoreAssessmentDocument,
} from '@/shared/types/assessment.types'

import { useFirestoreDocument } from './useFirestoreDocument'

interface UseAssessmentResult {
  assessment: FirestoreAssessmentDocument | null
  loading: boolean
  error: Error | null
  status: AssessmentProcessingStatus | null
}

/**
 * Hook to fetch assessment data from Firestore for a specific building UUID
 * @param buildingUuid - The UUID of the building
 * @returns Assessment data, loading state, error, and processed status
 */
export function useAssessment(buildingUuid: string | undefined): UseAssessmentResult {
  const path = buildingUuid ? `/assessments/${buildingUuid}` : ''

  const { data, loading, error } = useFirestoreDocument<FirestoreAssessmentDocument>(path)

  return {
    assessment: data,
    loading,
    error,
    status: data?.status || null,
  }
}
